import { Role, Permission } from "./types";

const allPermisions = () =>
	Object.values(Permission).reduce((r, c) => ({ ...r, [c]: true }), {});

export const RulesMap = {
	[Role.CC4AllAdmin]: allPermisions(),
	[Role.WebAdmin]: {
		[Permission.All]: true,
		[Permission.Generic]: false,
	},
	[Role.Supervisor]: {},
	[Role.AgentPlus]: {},
};
